//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Features.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Mode",1,0],[1,"ObjectsToProject",0,"Features.Subdivision.SelectCageObjectData",0],[0,"ProjectBothSides",1,0],[0,"ProjectionDirectionType",1,0],[0,"ProjectionVector",1,"Direction",0],[0,"TargetAxis",1,"Axis",0],[1,"TargetCageObjects",0,"Features.Subdivision.SelectCageObjectData",0],[1,"TargetCurves",0,"SelectDisplayableObjectList",0],[0,"TargetDynamicPlane",1,"CoordinateSystem",0],[1,"TargetFaces",0,"SelectDisplayableObjectList",0],[0,"TargetPlane",1,"Plane",0],[0,"TargetType",1,0],[0,"Type",1,0]],[[[],"OnTargetDynamicPlane",{},0,0],[[],"OnTargetPlane",{},0,0],[[],"OnTargetAxis",{},0,0]],[]];
SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx.Types = Object.freeze({
    "ToTarget" : "ToTarget", "ToAverage" : "ToAverage", "AlignNormal" : "AlignNormal"});

SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx.TargetTypes = Object.freeze({
    "InferredPlane" : "InferredPlane", "InferredAxis" : "InferredAxis", "DynamicPlane" : "DynamicPlane", "Plane" : "Plane", "Axis" : "Axis", "Curve" : "Curve", "Face" : "Face"});

SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx.ProjectionDirectionTypes = Object.freeze({
    "AlongNormal" : "AlongNormal", "AlongVector" : "AlongVector"});

SPLM.Features.Subdivision.SubdivisionProjectCageBuilderEx.ModeOptions = Object.freeze({
    "Linear" : "Linear", "Planar" : "Planar"});

export default SPLM;